import { render, staticRenderFns } from "./TemplateFontFilesAddForm.vue?vue&type=template&id=8161a8ca&scoped=true"
import script from "./TemplateFontFilesAddForm.vue?vue&type=script&lang=js"
export * from "./TemplateFontFilesAddForm.vue?vue&type=script&lang=js"
import style0 from "./TemplateFontFilesAddForm.vue?vue&type=style&index=0&id=8161a8ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8161a8ca",
  null
  
)

export default component.exports